import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LoginPage } from '@/pages/auth/login-page';

/**
 * `redirectPath` is the pathname of the originally requested protected route.
 * `redirectSearch` carries its raw search string (with or without leading `?`).
 * We store them separately so that `navigate({ to: path, search: parsed })` can
 * restore them accurately on successful login. Encoding the whole URL into a
 * single `to` value double-encodes and breaks TanStack Router's strict types.
 */
const loginSearchSchema = z.object({
  redirectPath: z.string().startsWith('/').optional().catch(undefined),
  redirectSearch: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema.parse,
  component: LoginPage,
});
